import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getTranscripts,
  getCanonicalTranscripts,
} from "../../../../state/selectors/GeneTranscripts.selector";
import { GeneTranscriptType } from "../../../componentTypes/GeneTranscriptsType";

const GeneTranscriptsCard = ({ card, canonicalTranscrips, transcripts }) => {
  const isDisabled = !transcripts || !transcripts.length;
  return (
    <CardWrapper {...card} isDisabled={isDisabled}>
      {canonicalTranscrips && (
        <div>
          {canonicalTranscrips.map((transcript, i) => {
            return i <= 1 ? (
              <div
                className="tw-font-bold"
                key={`${transcript.name}-${i}`}
                data-testid="gene-trancripts-transcript"
              >
                {transcript.name}
              </div>
            ) : null;
          })}
        </div>
      )}
    </CardWrapper>
  );
};

GeneTranscriptsCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  transcripts: GeneTranscriptType,
  canonicalTranscrips: PropTypes.arrayOf(PropTypes.shape({})),
};

GeneTranscriptsCard.defaultProps = {
  transcripts: [],
  canonicalTranscrips: [],
};

const mapStateToProps = (state) => ({
  transcripts: getTranscripts(state),
  canonicalTranscrips: getCanonicalTranscripts(state),
});

export default connect(mapStateToProps, {})(GeneTranscriptsCard);
